import moment from 'moment';
import React from 'react';

import { Button, Table } from 'semantic-ui-react';
import ChangeComplexStartDateModal from '../../../Menus/ControlUsers/ChangeComplexStartDateModal';
import { StyledLink } from '../../CreateProductPage/CreateProductStyles';
import { FitnessFuncContent, HeaderName } from '../userPageStyles';

const CoursesBlock = React.memo(
  ({ params, onUpdateStartDate, onUpdateIsPaid, setIsShowIsActiveCoursePopup, userId }) => {
    const [isShowCalendarModal, setIsShowCalendarModal] = React.useState(false);
    const [isCourseId, setIsCourseId] = React.useState(0);
    const [isCourseIndex, setIsCourseIndex] = React.useState(0);

    const onHandleStartComplexDate = (start_date) => {
      const startDate = moment(start_date).format('YYYY-MM-DD');

      setIsShowCalendarModal(false);
      onUpdateStartDate(startDate, isCourseId, isCourseIndex);
    };

    const onShowModal = (id, index) => {
      setIsShowCalendarModal(true);
      setIsCourseId(id);
      setIsCourseIndex(index);
    };

    return (
      <FitnessFuncContent>
        <Table celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <HeaderName>id курса</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName>статус</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName>статус оплаты</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName>тип оплаты</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName>дата старта</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName>дата конца</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName>питание</HeaderName>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <HeaderName> тренировки</HeaderName>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {params &&
              params.map((param, index) => (
                <Table.Row key={param.id}>
                  <Table.Cell>{param.id}</Table.Cell>
                  <Table.Cell>
                    <p>{param.status_course.name}</p>
                    {param.status_course.id === 3 && (
                      <Button
                        onClick={() =>
                          setIsShowIsActiveCoursePopup(param.start_date, param.id, index)
                        }
                      >
                        Перевести в активный
                      </Button>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {param.is_paid ? (
                      'Оплачено'
                    ) : (
                      <div>
                        <p>Не оплачено</p>
                        <Button onClick={() => onUpdateIsPaid(false, param.id, index)}>
                          Отметить оплаченным
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                  <Table.Cell>{param.type_payment.name}</Table.Cell>
                  <Table.Cell>
                    {param.start_date ? (
                      <div>
                        <p>{param.start_date}</p>
                        <Button onClick={() => onShowModal(param.id, index)}>
                          Изменить дату старта
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button onClick={() => onShowModal(param.id, index)}>
                          Назначить дату старта
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                  <Table.Cell>{param.end_date || '-'}</Table.Cell>
                  <Table.Cell>
                    <StyledLink to={`/youslim2.0/nutritionCourse/user/${userId}/${param.id}`}>
                      Питание
                    </StyledLink>
                  </Table.Cell>
                  <Table.Cell>
                    {/* <StyledLink to={`/youslim2.0/trainingCourse/user/${userId}/${param.id}`}> */}
                    <StyledLink
                      to={`/youslim2.0/trainingCourse/user/${userId}/${param.training_video_course_id}`}
                    >
                      Тренировки
                    </StyledLink>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
        <ChangeComplexStartDateModal
          isShow={isShowCalendarModal}
          onClose={() => setIsShowCalendarModal(false)}
          changeComplexStartDate={onHandleStartComplexDate}
        />
      </FitnessFuncContent>
    );
  },
);

export default CoursesBlock;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/UserPage/CoursesBlock/index.jsx